import { QuestionCircleOutlined } from "@ant-design/icons";
import { Row, Col, Select, Tooltip, Input, message, Button } from "antd";
import React, { useState } from "react";
import DropdownSelect from "../../../components/generic/DropdownSelect";
import {
  delimitersList,
  fileManipulationList,
} from "../../../constants/List Constants";

import { XMLParser } from "fast-xml-parser";
import ManipulationTable from "./ManipulationTable";

const { Option } = Select;
function FileManipulation(props) {
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [nodes, setNodes] = useState([]);
  const [matchDisabled, setMatchDisabled] = useState(false);
  const [matchType, setMatchType] = useState("");
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [file, setFile] = useState("");
  const [showDelimiter, setShowDelimiter] = useState(false);
  const [delimiter, setDelimiter] = useState("");

  const handlefileTypeChange = (value) => {
    setFileType(value);
    value === "CSV" ? setShowDelimiter(true) : setShowDelimiter(false);
    setNodes([]);
  };
  const getContent = (file) => {
    const reader = new FileReader();
    if (file.name.toLowerCase().endsWith(".xml")) {
      message.error("Please upload an XML file");
      reader.onload = (e) => {
        const xmlText = e.target.result;

        const parser = new XMLParser({ ignoreAttributes: false });
        const result = parser.parse(xmlText);

        console.log("Parsed XML:", result);

        const extractedNodes = extractNodes(result);
        setNodes(extractedNodes);
      };
      reader.readAsText(file);
    } else if (file.name.toLowerCase().endsWith(".csv")) {
      reader.onload = (e) => {
        const csvData = e.target.result;
        const rows = csvData.split("\n");
        const headers = rows[0].split(",").map((header) => header.trim());
        setNodes(headers.map((header) => ({ key: header, value: header })));
      };
      reader.readAsText(file);
    } else {
      message.error("Please upload a CSV or XML file");
      setNodes([]);
      return false;
    }
  };
  const onClickColumnUpdate = () => {
    setUpdateModalOpen(!updateModalOpen);
  };
  const handleDelimiterSelection = (value) => {
    setDelimiter(value);
  };

  const extractNodes = (obj, parentKey = "") => {
    let extracted = new Set();
    const traverse = (obj) => {
      for (const key in obj) {
        if (typeof obj[key] === "object") {
          traverse(obj[key]);
        } else if (obj[key]) {
          extracted.add(key);
        }
      }
    };
    traverse(obj);
    return Array.from(extracted).map((key) => ({ key, value: key }));
  };
  return (
    <div>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Match Filename *{" "}
            <Tooltip title="Enter the name of the file which should match the criteria from dropdown selection">
              <QuestionCircleOutlined
                style={{
                  color: "rgba(0,0,0,.45)",
                }}
              />
            </Tooltip>
          </p>
        </Col>
        <Col span={6}>
          <Select
            placeholder="match type"
            onChange={(e) => {
              if (e === "any") {
                setFileName("");
                setMatchDisabled(true);
              } else {
                setMatchDisabled(false);
              }
              setMatchType(e);
            }}
            style={{ width: "80%" }}
          >
            <Option value="equals">Equals</Option>
            <Option value="contains">Contains</Option>
            <Option value="any">Any</Option>
          </Select>
        </Col>
        <Col span={12}>
          <Input
            value={fileName}
            disabled={matchDisabled}
            placeholder="file name"
            onChange={(e) => setFileName(e.target.value)}
            width="100%"
          />
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">File Type *</p>
        </Col>
        <Col span={18}>
          <DropdownSelect
            placeholder="select file type"
            options={fileManipulationList}
            valueKey="value"
            labelKey="label"
            onSelect={handlefileTypeChange}
          />
        </Col>
      </Row>
      {showDelimiter && (
        <Row>
          <Col span={6}>
            <p className="spec-modal-label">
              Select Delimiter *{" "}
              <Tooltip title="The character separating columns in your CSV file. Must match the file's actual delimiter.">
                <QuestionCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
              </Tooltip>
            </p>
          </Col>
          <Col span={18}>
            <DropdownSelect
              options={delimitersList}
              valueKey="value"
              labelKey="label"
              placeholder="Select delimiter"
              onSelect={handleDelimiterSelection}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Sample with header *{" "}
            <Tooltip title="We will only use the header from the uploaded file for mapping purposes. This is not the Test File">
              <QuestionCircleOutlined
                style={{
                  color: "rgba(0,0,0,.45)",
                }}
              />
            </Tooltip>
          </p>
        </Col>
        <Col span={18}>
          <p>
            <input
              type="file"
              disabled={!fileType}
              onChange={(e) => {
                if (!fileType) {
                  message.error("Please select a file type first");
                  return;
                }
                getContent(e.target.files[0]);
                setFile(e.target.files[0]);
              }}
              style={{
                color: "black",
                cursor: !fileType ? "not-allowed" : "pointer",
              }}
            />
          </p>
        </Col>
      </Row>
      {nodes.length > 0 && (
        <div>
          <Row>
            <Col span={18}>
              <Button className="db-add" onClick={onClickColumnUpdate}>
                Select Columns to Update
              </Button>
            </Col>
          </Row>
          <ManipulationTable
            nodes={nodes}
            isOpen={updateModalOpen}
            handleModal={onClickColumnUpdate}
          />
        </div>
      )}
    </div>
  );
}

export default FileManipulation;
